import { Base } from "@/atoms-react/text/Text.react";
import { CheckCircleIcon } from "@heroicons/react/24/outline";

export const SuccessCard = ({ text }: { text: string }) => (
  <div className="flex items-center gap-5 rounded-sm border border-green-600 bg-green-100 px-5 py-4 dark:bg-green-700">
    <CheckCircleIcon className="size-6 text-green-600" />
    <Base>{text}</Base>
  </div>
);
